/* ============================================================================
 * rift-addon-sync.js — keep Rift "Finished Side Panel" lines with their cabinet.
 *
 * A Rift cabinet with finished sides is added together with one $90 Finished
 * Side Panel line per side (sections/rift-picker.liquid). Both lines carry the
 * same hidden _Rift link. When the cabinet's quantity changes or it is removed
 * in the cart, each side line follows: same quantity as its cabinet, or gone.
 * Lines without a _Rift link are never touched.
 * ==========================================================================*/
(function () {
  'use strict';
  var SKU = 'RIFT-FIN-SIDE';
  var busy = false;

  function link(it) { return it.properties && it.properties['_Rift link']; }
  function plan(cart) {
    if (!cart || !cart.items) return null;
    var cab = {}, updates = {}, n = 0;
    cart.items.forEach(function (it) { if (it.sku !== SKU && link(it)) cab[link(it)] = (cab[link(it)] || 0) + it.quantity; });
    cart.items.forEach(function (it) {
      if (it.sku !== SKU || !link(it)) return;
      var want = cab[link(it)] || 0;
      if (it.quantity !== want) { updates[it.key] = want; n++; }
    });
    return n ? updates : null;
  }
  function sync(cart) {
    var updates = plan(cart);
    if (!updates || busy) return;
    busy = true;
    var drawer = document.querySelector('cart-drawer');
    var body = { updates: updates };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (state) {
      busy = false;
      if (/^\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
      if (drawer && state && state.sections) drawer.renderContents(state);
    }).catch(function () { busy = false; });
  }
  function check() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(sync).catch(function () {});
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'cart-items') return;
      if (event.cartData && event.cartData.items) sync(event.cartData); else check();
    });
  }
  if (/^\/cart\/?$/.test(window.location.pathname)) check();
})();
